export default function getScalingParameters(metaData, imageId) {
    const modalityLutModule = metaData.get('modalityLutModule', imageId) || {};
    const generalSeriesModule = (metaData.get('generalSeriesModule', imageId) ||
        {});
    const { modality } = generalSeriesModule;
    const rescaleSlope = modalityLutModule.rescaleSlope;
    const rescaleIntercept = modalityLutModule.rescaleIntercept;
    const normalizedRescaleSlope = rescaleSlope ?? 1;
    const normalizedRescaleIntercept = rescaleIntercept ?? 0;
    const scalingModules = metaData.get('scalingModule', imageId) || {};
    const hasPTScaling = modality === 'PT' &&
        typeof scalingModules.suvbw === 'number' &&
        !isNaN(scalingModules.suvbw);
    const hasDoseScaling = modality === 'RTDOSE' &&
        typeof scalingModules.DoseGridScaling === 'number' &&
        !isNaN(scalingModules.DoseGridScaling);
    if (normalizedRescaleSlope === 1 &&
        normalizedRescaleIntercept === 0 &&
        !hasPTScaling &&
        !hasDoseScaling) {
        return undefined;
    }
    const scalingParameters = {
        rescaleSlope: normalizedRescaleSlope,
        rescaleIntercept: normalizedRescaleIntercept,
        modality,
    };
    return {
        ...scalingParameters,
        ...(modality === 'PT' && { suvbw: scalingModules.suvbw }),
        ...(modality === 'RTDOSE' && {
            doseGridScaling: scalingModules.DoseGridScaling,
            doseSummation: scalingModules.DoseSummation,
            doseType: scalingModules.DoseType,
            doseUnit: scalingModules.DoseUnit,
        }),
    };
}
